import { createSlice } from "@reduxjs/toolkit";

export const ActiveTab = createSlice({
  name: "drawerTabs",
  initialState: {
    tabs: {
      catalogue: "productList",
      client: "bussiness",
      notification: "notification",
      subscription: "invoice",
      admin_setting: "personal",
      sales: "summary",
      clientUsers: "clientList",
      clientCatalogue: "service",
      teams: "teamMemebrs",
      client_setting: "personal",
      marketPlace: "profiles",
      branch: "branch",
      // Company Tabs
      company_worker_client: "workerList",
      company_catalogue: "service_category",
      compnay_subscription: "invoice",
      compnay_settings: "company_details",
      // Education Tabs
      education_admission: "ed_all_admissions",
      education_classes: "ed_all_classes",
      education_settings: "ed_school_detail",
      education_report_card: "ed_generate_card",



    },
  },
  reducers: {
    setActiveTab: (state, action) => {
      state.tabs = action.payload;
    },
  },
});

export const { setActiveTab } = ActiveTab.actions;

export default ActiveTab.reducer;
